/**
 * Curated subset of lucide-react icon names useful for hotkey labels.
 * Server-side iconName is a free string; this list is just the UI
 * picker convenience. The picker is a fixed dropdown over this list —
 * there is no free-text icon input today, so an icon outside this list
 * can only be set via the API directly. (H-131: removed a stale comment
 * that claimed a "custom" text input the picker doesn't offer.)
 */
export const ICON_OPTIONS = [
  'shopping_bag',
  'shopping_cart',
  'local_grocery_store',
  'local_florist',
  'local_drink',
  'local_pizza',
  'restaurant',
  'lunch_dining',
  'icecream',
  'bakery_dining',
  'liquor',
  'wine_bar',
  'coffee',
  'cake',
  'cookie',
  'set_meal',
  'egg',
  'kitchen',
  'spa',
  'pets',
  'percent',
  'discount',
  'sell',
  'redeem',
  'card_giftcard',
  'workspace_premium',
  'star',
  'favorite',
  'bookmark',
  'label',
  'category',
  'inventory_2',
  'shopping_basket',
  'storefront',
  'point_of_sale',
  'payments',
  'credit_card',
  'savings',
  'attach_money',
  'price_check',
] as const;

export type IconOption = (typeof ICON_OPTIONS)[number];
